export * from "./pTable.type";
export * from "./PTable.vue";
export * from "./PPersonalizeTable.vue";
export * from "./PTableSimple.vue";
